import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Chat-Loading.gif'


const _withScopeId = (n: any) => (_pushScopeId("data-v-8654bbbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-auto min-h-14 items-center justify-between border-t p-2" }
const _hoisted_2 = { class: "flex w-full items-center rounded-xl px-2" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "chat-loading",
  class: "h-7 w-14"
}

import {
  PhPaperPlaneRight,
} from '@phosphor-icons/vue';
import {
  computed,
  onMounted,
  ref,
  watch,
} from 'vue';
import {
  type ConversationSocketService,
  getConversationSocketService,
} from '@/services/ConversationSocketService';
import {
  useStore,
} from '@/store';

const maxLine = 2;


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatInput',
  setup(__props) {

const newMessage = ref('');

const newMessageRef = ref<HTMLTextAreaElement>();

let conversationSocketService: ConversationSocketService;

const conversationThreadStore = useStore.conversationThread;

const isSendMessageDisabled = computed(() => !newMessage.value.trim().length);

function sendMessage(): void {
  if (conversationThreadStore.isReplyLoading) {
    return;
  }

  if (newMessage.value) {
    conversationSocketService.sendMessage(newMessage.value.trim());
    newMessage.value = '';
  }

  if (newMessageRef.value) {
    newMessageRef.value.style.height = 'auto';
  }
}

function adjustInputSize(): void {
  if (!newMessageRef.value) {
    return;
  }

  newMessageRef.value.style.height = 'auto';
  newMessageRef.value.style.height = `${newMessageRef.value.scrollHeight}px`;

  const fontSize = parseFloat(getComputedStyle(newMessageRef.value).fontSize);
  const maxHeight = maxLine * 1.5 * fontSize;

  if (newMessageRef.value.scrollHeight > maxHeight) {
    newMessageRef.value.style.overflowY = 'auto';
    // Since we're using text-base, the conversion is 1.5x to px.
    newMessageRef.value.style.maxHeight = `${maxHeight}px`; // Adjust as needed
  } else {
    newMessageRef.value.style.overflowY = 'hidden';
    newMessageRef.value.style.maxHeight = 'none';
  }
}

function resetInputSize(): void {
  if (!newMessageRef.value) {
    return;
  }
  const textarea = newMessageRef.value;
  textarea.style.height = `${newMessageRef.value.scrollHeight}px`;
  textarea.style.overflowY = 'auto';
}

function _focusChatInput(): void {
  if (!newMessageRef.value) {
    return;
  }

  newMessageRef.value.readOnly = true;
  newMessageRef.value.focus();

  setTimeout(() => {
    if (newMessageRef.value) {
      newMessageRef.value.readOnly = false;
    }
  }, 50);
}

watch(() => conversationThreadStore.messages.length === 0, () => {
  newMessage.value = '';
  _focusChatInput();
});

onMounted(() => {
  conversationSocketService = getConversationSocketService();
  _focusChatInput();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        ref_key: "newMessageRef",
        ref: newMessageRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newMessage).value = $event)),
        placeholder: "Have a question? Ask now!",
        rows: "1",
        class: "h-auto w-full resize-none overflow-y-hidden border-none bg-transparent text-base leading-6 outline-none md:px-0",
        onInput: adjustInputSize,
        onBlur: resetInputSize,
        onKeyup: _withKeys(sendMessage, ["enter"])
      }, null, 544), [
        [_vModelText, newMessage.value]
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass({
        'btn-disabled': isSendMessageDisabled.value,
      }),
      disabled: isSendMessageDisabled.value,
      onClick: sendMessage
    }, [
      (_unref(conversationThreadStore).isReplyLoading)
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : (_openBlock(), _createBlock(_unref(PhPaperPlaneRight), {
            key: 1,
            class: _normalizeClass(["size-6", {
          'fill-gray-500': isSendMessageDisabled.value,
          'fill-blue-500 hover:fill-blue-600': !isSendMessageDisabled.value,
        }]),
            weight: "fill"
          }, null, 8, ["class"]))
    ], 10, _hoisted_3)
  ]))
}
}

})